<div *ngIf='hasCloseBtn' class='back-btn' (click)='location.back()'>
  <fa-icon [icon]='faTimes'></fa-icon>
</div>
<div class="row mb-0 pt-1 pb-2 position-relative">
  <div class="col-sm-12">
    <!-- <ol class="breadcrumb" [class.home-breadcrumb]='!hasBackBtn'>
      <li *ngIf='hasBackBtn'>
        <span (click)='location.back()'>
          Back
        </span>
      </li>
      <li *ngIf='!hasBackBtn' (click)='goToHome()'>
        <span>
          Home
        </span>
      </li>
      <li *ngFor="let breadcrumb of breadcrumbs; let i = index">
        <span *ngIf='breadcrumb.stopNav'>
          {{ breadcrumb.label }}
        </span>
        <span *ngIf='!breadcrumb.stopNav' (click)="redirect(breadcrumb.url, i)" routerLinkActive="active">
          {{ breadcrumb.label }}
        </span>
      </li>
    </ol> -->
  </div>
</div>
